module.exports = __webpack_public_path__ + "static/media/spacex.f2b1b847.jpg";